import React from 'react'
import { Typography } from '@mui/material'
import { useTranslation } from 'react-i18next'
import BasicModal from '@/components/UI/Dialog/Dialog'

interface DeleteLearnerQuestionsPopupProps {
  show: boolean
  onHide: () => void
  onDelete: (e: React.MouseEvent, selectedRows: string[]) => void
  selectedRows: string[]
}

const DeleteLearnerQuestionsPopup: React.FC<
  DeleteLearnerQuestionsPopupProps
> = ({ show, onHide, onDelete, selectedRows }) => {
  const { t } = useTranslation('translation')

  return (
    <BasicModal
      open={show}
      onClose={onHide}
      title={t('Delete Question(s)')}
      showCloseButton
      sx={{ width: 430, height: 'auto' }}
      footerActions={[
        {
          title: t('Cancel'),
          variant: 'outlined',
          onClick: onHide,
        },
        {
          title: t('Delete'),
          variant: 'contained',
          color: 'error',
          onClick: (e: React.MouseEvent) => onDelete(e, selectedRows),
        },
      ]}
    >
      <Typography variant="body2" sx={{ mt: 1 }}>
        {t(
          'Deleting question would remove the question from the learner board, are you sure you would like to delete?',
        )}
      </Typography>
    </BasicModal>
  )
}

export default DeleteLearnerQuestionsPopup
